export interface MetadataParser {
  parse: (filters: string) => Record<string, string> | undefined;
}

export const createMetadataParser: () => MetadataParser = () => {
  function parse(stringifiedMetadata: string) {
    if (!/^(?:\S+:\S+(?:\s\|\|\s)?)+$/.test(stringifiedMetadata)) return {};
    return Object.fromEntries(stringifiedMetadata.split(' || ').map((s) => s.split(':'))) as Record<string, string>;
  }

  return { parse };
};
